import Vue from 'vue'
import redirectToPage from './redirectToPage'

Vue.mixin(redirectToPage);
